<script>
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import forminput from "@/router/views/formcomponet/forminput.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import obirim from "@/models/obirim";
import moment from "moment";
import useVuelidate from "@vuelidate/core";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, obirim],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
    };
  },
  components: {
    forminput, treeselect,Multiselect
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          this.Post("obirim", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.obirimData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("obirim", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.obirimData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() { },
  },

  computed: {
amirSelectOptions() {
    const arr = this.FormDataType?.Amirids?.ComboDataArray
    if (!Array.isArray(arr)) return []

    return arr
      .filter(x => x && x.id)
      .map(item => ({
        value: String(item.id),
        label: item.label || ""
      }))
  },
  
uygulamaSelectOptions() {
    const arr = this.FormDataType?.Uygulamaids?.ComboDataArray
    if (!Array.isArray(arr)) return []

    return arr
      .filter(x => x && x.id)
      .map(item => ({
        value: String(item.id),
        label: item.label || ""
      }))
  }
  }
};
</script>
<template>
  <b-modal v-model="ModalOpen" id="obirim" size="lg" :title="this.AddEdit == 'Edit'
    ? 'Kayıt Düzenle'
    : 'Yeni Kayıt Ekle'
    " title-class="font-18" hide-footer>
    <Form @submit.prevent="onSubmit" v-if="FormData">


      <div class="row">

        <forminput class="col-lg-6" :FormDataType="FormDataType.Birimkodu" :Value="FormData.Birimkodu"
          :v="v$.FormData.Birimkodu" @input="FormData.Birimkodu = $event.target.value" />
        <forminput class="col-lg-6" :FormDataType="FormDataType.Birimadi" :Value="FormData.Birimadi"
          :v="v$.FormData.Birimadi" @input="FormData.Birimadi = $event.target.value" />

        <forminput class="col-lg-6" :FormDataType="FormDataType.Temsilci" :Value="FormData.Temsilci"
          :v="v$.FormData.Temsilci" @input="FormData.Temsilci = $event.target.value" />

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Ustbirimid.FieldTitle"
          :key="FormData.Ustbirimid">
          <treeselect :multiple="false" :options="FormDataType.Ustbirimid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Ustbirimid" />
          <treeselect-value :value="FormData.Ustbirimid" />
        </b-form-group>

        <forminput class="col-lg-6" :FormDataType="FormDataType.Telefon" :Value="FormData.Telefon"
          :v="v$.FormData.Telefon" @input="FormData.Telefon = $event.target.value" />
        <forminput class="col-lg-6" :FormDataType="FormDataType.Eposta" :Value="FormData.Eposta" :v="v$.FormData.Eposta"
          @input="FormData.Eposta = $event.target.value" />
        <forminput class="col-lg-6" :FormDataType="FormDataType.Adres" :Value="FormData.Adres" :v="v$.FormData.Adres"
          @input="FormData.Adres = $event.target.value" />

          
        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Ustbirimid.FieldTitle"
          :key="FormData.Ustbirimid">
          <treeselect :multiple="false" :options="FormDataType.Ustbirimid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Ustbirimid" />
          <treeselect-value :value="FormData.Ustbirimid" />
        </b-form-group>



<b-form-group class="col-lg-6" :label="FormDataType.Amirids.FieldTitle">
  <Multiselect
    v-model="FormData.Amirids"
    mode="tags"
    :close-on-select="false"
    :searchable="true"
    :options="amirSelectOptions"
    valueProp="value"
    label="label"
    trackBy="label"
    placeholder="Seçiniz..."
  />
</b-form-group>


<b-form-group class="col-lg-6" :label="FormDataType.Uygulamaids.FieldTitle">
  <Multiselect
    v-model="FormData.Uygulamaids"
    mode="tags"
    :close-on-select="false"
    :searchable="true"
    :options="uygulamaSelectOptions"
    valueProp="value"
    label="label"
    trackBy="label"
    placeholder="Seçiniz..."
  />
</b-form-group>


         <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Amirids.FieldTitle" v-if="0"
          :key="FormData.Amirids">
          <treeselect :multiple="true" :options="FormDataType.Amirids.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Amirids" />
          <treeselect-value :value="FormData.Amirids" />
            </b-form-group>

      </div>
      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
